import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { change, Field, reduxForm } from "redux-form";
import { withTranslation } from "react-i18next";
import { Col, Container, Row, Card, CardBody, Button } from "reactstrap";
import renderSelectField from "../../../shared/components/form/Select";
import renderFileInputField from "../../../shared/components/form/FileInput";
import Modal from "@material-ui/core/Modal";
import ModalTheme from "../../../shared/components/Modal";
import { MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";
import { withStyles } from "@material-ui/core/styles";
import moment from "moment";
import MomentUtils from "@date-io/moment";
import history from "../../../history";
import renderMultiSelectField from "../../../shared/components/form/MultiSelect";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

const styles = (theme) => ({
  date: {
    width: 400,
    fontFamily: "Roboto",
    border: "none",
    fontSize: 13,
    lineHeight: 1.6,
  },
});

const renderField = ({
  input,
  disabled,
  placeholder,
  type,
  meta: { touched, error },
  style,
}) => (
  <div
    className="form__form-group-input-wrap form__form-group-input-wrap--error-above"
    style={style}
  >
    <input
      {...input}
      placeholder={placeholder}
      type={type}
      disabled={disabled}
    />
    {touched && error && (
      <span className="form__form-group-error">{error}</span>
    )}
  </div>
);

renderField.propTypes = {
  input: PropTypes.shape().isRequired,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
};

renderField.defaultProps = {
  placeholder: "",
  meta: null,
  type: "text",
};

const AddUser = (props) => {
  const [user, setUser] = useState("");
  const [password, setPassword] = useState("");
  const [passwordConfirm, setPasswordConfirm] = useState("");
  const [name, setName] = useState("");
  const [lastName1, setLastName1] = useState("");
  const [lastName2, setLastName2] = useState("");
  const [gender, setGender] = useState({ value: "", label: "" });
  const [birthday, setBirthday] = useState(new Date());
  const [typeDocument, setTypeDocument] = useState({ value: "", label: "" });
  const [documentNumber, setDocumentNumber] = useState("");
  const [cellphone, setCellphone] = useState("");
  const [telephone, setTelephone] = useState("");
  const [email, setEmail] = useState("");
  const [openMap, setOpenMap] = useState(false);
  const [userId, setUserId] = useState(null);
  const [errors, setErrors] = useState({});
  const [professional, setProfessional] = useState("");
  const [medicalRecord, setMedicalRecord] = useState("");
  const [rethus, setRethus] = useState("");
  const [healthLicense, setHealthLicense] = useState("");
  //const [specialty, setSpecialty] = useState('');
  const [specialties, setSpecialties] = useState([]);
  const [specialtiesSpec, setSpecialtySpec] = useState([]);
  const [city, setCity] = useState("");
  const [department, setDepartment] = useState("");
  const [cities, setCities] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [country, setCountry] = useState("");
  const [countries, setCountries] = useState([]);
  const [address, setAddress] = useState("");
  const [file, setFile] = useState(null);
  const [profile, setProfile] = useState({});
  const [profiles, setProfiles] = useState([]);
  const [charge, setCharge] = useState(0);
  const [charges, setCharges] = useState([]);
  const [load, setLoad] = useState(false);
  const [useModal, setUseModal] = useState(false);
  const [roles, setRoles] = useState(null);
  const [rol, setRol] = useState(null);
  const [dependencias, setDependencias] = useState(null);
  const [dependencia, setDependencia] = useState(null);

  useEffect(() => {
    setLoad(true);
    loadCharge();
    if (props.location.state.userId !== 0) {
      setUserId(props.location.state.userId);
      loadDataUser().then((dataUser) => {
        console.log(dataUser);
        Promise.all([
          loadSpecialities(),
          loadCountries(),
          loadDepartment(),
          loadProfiles(),
        ])
          .then((results) => {
            setSpecialties(results[0]);
            setCountries(results[1]);
            setDepartments(results[2]);
            setProfiles(results[3]);
            setLoad(false);
          })
          .catch((error) => {
            console.log(error);
          });
      });
    } else {
      Promise.all([
        loadSpecialities(),
        loadCountries(),
        loadDepartment(),
        loadProfiles(),
      ])
        .then((results) => {
          setSpecialties(results[0]);
          setCountries(results[1]);
          setDepartments(results[2]);
          setProfiles(results[3]);
          setLoad(false);
        })
        .catch((error) => {
          console.log(error);
        });
    }
    loadRoles();
    loadDependencias();
  }, []);

  const loadSpecialities = () => {
    return new Promise((resolve, reject) => {
      fetch(process.env.REACT_APP_PUBLIC_URL + "especialidad/listar", {
        method: "GET",
        headers: {
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      })
        .then((response) => {
          console.log(response);
          return response.json();
        })
        .then((specialists) => {
          resolve(specialists);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const loadDataUser = () => {
    var data = { user_id: userId };
    return new Promise((resolve, reject) => {
      fetch(process.env.REACT_APP_PUBLIC_URL + "usuario/consultar", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify(data),
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          if (data.existe) {
            console.log("DATOOOS ",data.contenido[0]);
            resolve(data.contenido[0]);
          } else {
            resolve({});
          }
        })
        .catch((error) => {
          console.error("Error:", error);
          reject(error);
        });
    });
  };

  const loadCountries = () => {
    return new Promise((resolve, reject) => {
      fetch(process.env.REACT_APP_PUBLIC_URL + "paises/listar", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          resolve(data);
        })
        .catch((error) => {
          console.error("Error:", error);
          resolve(error);
        });
    });
  };

  const loadDepartment = (paicod) => {
    return new Promise((resolve, reject) => {
      const getURL = paicod
        ? `departamentos/listar?id_pais=${paicod}`
        : `departamentos/listar`;
      fetch(process.env.REACT_APP_PUBLIC_URL + getURL, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          resolve(data);
        })
        .catch((error) => {
          console.error("Error:", error);
          resolve(error);
        });
    });
  };

  const loadCities = (depcod) => {
    var data = { id_dpto: depcod };
    return new Promise((resolve, reject) => {
      fetch(process.env.REACT_APP_PUBLIC_URL + "ciudades/listar", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify(data),
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          //console.log(data);
          resolve(data);
        })
        .catch((error) => {
          console.error("Error:", error);
          resolve(error);
        });
    });
  };

  const loadProfiles = () => {
    return new Promise((resolve, reject) => {
      fetch(process.env.REACT_APP_PUBLIC_URL + "perfiles/listar", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      })
        .then((response) => {
          return response.json();
        })
        .then((profiles) => {
          //setProfiles(profiles)
          resolve(profiles);
        })
        .catch((error) => {
          console.error("Error:", error);
          reject(error);
        });
    });
  };

  const loadCharge = async () => {
    await fetch(process.env.REACT_APP_PUBLIC_URL + "cargo/listar", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        setCharges(data);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const loadRoles = () => {
    return new Promise((resolve, reject) => {
      fetch(process.env.REACT_APP_PUBLIC_URL + "rol/listar", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          const listaRoles = data.results.map((rol) => {
            return { value: rol.id_gd_roles, label: rol.nombre };
          });
          setRoles(listaRoles);
          console.log("rol", data);
        })
        .catch((error) => {
          console.error("Error:", error);
          reject(error);
        });
    });
  };

  const loadDependencias = () => {
    return new Promise((resolve, reject) => {
      fetch(process.env.REACT_APP_PUBLIC_URL + "dependencia/listar?estado=A", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          const listaDependencias = data.results.map((dependencia) => {
            return {
              value: dependencia.id_gd_dependencia,
              label: dependencia.descripcion,
            };
          });
          setDependencias(listaDependencias);
        })
        .catch((error) => {
          console.error("Error:", error);
          reject(error);
        });
    });
  };

  const countriesOption = () => {
    if (countries.length > 0) {
      return countries.map((country) => {
        return { value: country.id, label: country.painom, id: country.id };
      });
    }
  };

  const departmentsOption = () => {
    if (departments.length > 0) {
      return departments.map((department) => {
        return {
          value: department.depcod,
          label: department.depnom,
          id: department.id,
        };
      });
    }
  };

  const citiesOptions = () => {
    return cities.map((city) => {
      return { value: city.ciucod, label: city.ciunom, id: city.id };
    });
  };

  const profilesOptions = () => {
    let data = [];
    if (profiles.length > 0) {
      profiles.map((profile) => {
        if (profile.estado_perfil === 1) {
          data.push({
            value: profile.id_perfil,
            label: profile.nombre,
            id: profile.id_perfil,
          });
        }
      });
    }
    return data;
  };

  const cargosOptions = () => {
    let listCargos = [];
    if (charges.length > 0) {
      charges.map((charge) => {
        listCargos.push({
          value: charge.id_cargo,
          label: charge.cargo,
          id: charge.id_cargo,
        });
      });
    }
    return listCargos;
  };

  const validate = (professional) => {
    var errors = {};
    if (user === "") {
      errors.user = "Ingrese un usuario";
    } else {
      delete errors.user;
    }

    if (typeDocument.value === "") {
      errors.typeDocument = "Seleccione un tipo de documento";
    } else {
      delete errors.typeDocument;
    }

    if (documentNumber === "") {
      errors.documentNumber = "Ingrese un número de documento";
    } else {
      delete errors.documentNumber;
    }

    if (password === "") {
      errors.password = "Ingrese la contraseña";
    } else {
      delete errors.password;
    }

    if (passwordConfirm === "") {
      errors.passwordConfirm = "Confirma la contraseña";
    } else {
      delete errors.passwordConfirm;
    }

    if (passwordConfirm !== password) {
      errors.passwordConfirm = "la contraseña no conside";
    } else {
      delete errors.passwordConfirm;
    }

    if (name === "") {
      errors.name = "Ingrese un nombre";
    } else {
      delete errors.name;
    }

    if (lastName1 === "") {
      errors.lastName1 = "Ingrese el primer apellido";
    } else {
      delete errors.lastName1;
    }

    if (lastName2 === "") {
      errors.lastName2 = "Ingrese el segundo apellido";
    } else {
      delete errors.lastName2;
    }

    if (gender.value === "") {
      errors.gender = "Seleccione un genero";
    } else {
      delete errors.gender;
    }

    if (cellphone === "") {
      errors.cellphone = "Ingrese un teléfono";
    } else {
      delete errors.cellphone;
    }

    if (telephone === "") {
      errors.telephone = "Ingrese un teléfono";
    } else {
      delete errors.telephone;
    }

    if (!email) {
      errors.email = "El campo de email no debe estar vacio";
    } else if (!/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/i.test(email)) {
      errors.email = "No es una dirección de correo valida";
    } else {
      delete errors.email;
    }

    if (!country) {
      errors.country = "Seleccione un pais";
    } else {
      delete errors.country;
    }

    if (!department) {
      errors.department = "Seleccione un departamento";
    } else {
      delete errors.department;
    }

    if (!city) {
      errors.city = "Seleccione un ciudad";
    } else {
      delete errors.city;
    }
    console.log(professional);
    if (professional === "Si") {
      if (!rethus) {
        errors.rethus = "Ingrese un rethus";
      } else {
        delete errors.rethus;
      }
      if (!medicalRecord) {
        errors.medicalRecord = "Ingrese un registro medico";
      } else {
        delete errors.medicalRecord;
      }

      if (!healthLicense) {
        errors.healthLicense = "Ingrese una licencia de salud ocupacional";
      } else {
        delete errors.healthLicense;
      }

      /*
            if (!specialty) {
                errors.specialty = 'Seleccione una especialidad';
            } else {
                delete errors.specialty;
            }
            */

      if (!file) {
        errors.file = "Seleccione un archivo ";
      } else {
        delete errors.file;
      }

      if (file !== null) {
        var fileType = file.file["type"];
        const validImageTypes = ["image/gif", "image/jpeg", "image/png"];
        if (!validImageTypes.includes(fileType)) {
          // invalid file type code goes here.
          errors.file =
            "El tipo de archivo no es una imagen (Seleccione un archivo imagen)";
        } else {
          delete errors.file;
        }
      }
    }

    console.log(errors);
    setErrors(errors);
    if (Object.keys(errors).length > 0) {
      return true;
    } else {
      return false;
    }
  };

  const createUser = () => {
    console.log("rol",rol);
    console.log("dependencia",dependencia);

    let data = {};

    if (professional === "No") {
      if (!validate(professional)) {
        const direccion = {
          id_pais: country.value,
          id_dpto: department.value,
          id_ciudad: city.value,
          direccion: address,
        };

        let dataProf = new FormData();

        dataProf.append("firma", null);
        dataProf.append("tipDoc", typeDocument.value);
        dataProf.append("numDoc", documentNumber);
        dataProf.append("nombres", name);
        dataProf.append("ape1", lastName1);
        dataProf.append("ape2", lastName2);
        dataProf.append("sexo", gender.value);
        dataProf.append(
          "fec_nacimiento",
          moment(birthday).format("YYYY/MM/DD")
        );
        dataProf.append("tel_fijo", telephone);
        dataProf.append("celular", cellphone);
        dataProf.append("id_cargo", parseInt(charge));
        dataProf.append("correo", email);
        dataProf.append("username", user);
        dataProf.append("password", password);
        dataProf.append("id_perfil", profile.id);
        dataProf.append("direccion", JSON.stringify(direccion));
        dataProf.append("id_gd_roles", rol);
        dataProf.append("id_gd_dependencia", dependencia);

        console.log("dataProf", dataProf);
        

        fetch(process.env.REACT_APP_PUBLIC_URL + "usuario/create", {
          method: "POST",
          headers: {
            authorization: "Bearer " + sessionStorage.getItem("token"),
          },
          body: dataProf,
        })
          .then((response) => {
            if (response.status !== 500 && response.status !== 403) {
              console.log(response);
              //setUseModal(true);
              alert("Usuario creado correctamente");
              history.push({
                pathname: process.env.PUBLIC_URL + "/config/manage-users",
              });
            }
          })
          .catch((error) => {
            alert("No se pudo crear el usuario");
          });
      }
    } else if (professional === "Si") {
      if (!validate(professional)) {
        data = {
          tipDoc: typeDocument.value,
          numDoc: documentNumber,
          ape1: lastName1,
          ape2: lastName2,
          nombres: name,
          regMed: medicalRecord,
          rethus: rethus,
          licOC: healthLicense,
          dire: {
            id_pais: country.value,
            id_dpto: department.value,
            id_ciudad: city.value,
            direccion: address,
          },
          telf: telephone,
          cel1: cellphone,
          cel2: "",
          correo: email,
          firma:
            file != null
              ? { archivo: file.file, name: file.name }
              : { archivo: "", name: "" },
          tipoProf: "Médico",
          tipoCont: "Fijo",
          esp: JSON.stringify(specialtiesSpec), //ESPECIALIDAD
          username: user,
          password: password,
          id_perfil: profile.id,
          id_rol: rol.id_gd_roles,
          id_gd_dependencia: dependencia.id_gd_dependencia
        };
        //console.log(data);
        console.log(password);
        var dataFile = new FormData();
        var typeDoc = typeDocument.value;
        var ciudad = city.value;
        console.log([typeDoc, ciudad]);
        dataFile.append("archivo", file != null ? file.file : null);
        dataFile.append("tipDoc", typeDoc);
        dataFile.append("numDoc", documentNumber);
        dataFile.append("ape1", lastName1);
        dataFile.append("ape2", lastName2);
        dataFile.append("nombres", name);
        dataFile.append("regMed", medicalRecord);
        dataFile.append("rethus", rethus);
        dataFile.append("licOC", healthLicense);
        dataFile.append("id_ciudad", ciudad);
        dataFile.append("dire", address);
        dataFile.append("telf", telephone);
        dataFile.append("cel1", cellphone);
        dataFile.append("cel2", "");
        dataFile.append("correo", email);
        dataFile.append("sexo", gender.value);
        dataFile.append(
          "fec_nacimiento",
          moment(birthday).format("YYYY/MM/DD")
        );
        dataFile.append("tipoProf", "Médico");
        dataFile.append("tipoCont", "Fijo");
        dataFile.append("esp", JSON.stringify(specialtiesSpec));
        dataFile.append("tipoCont", "Fijo");
        dataFile.append("id_perfil", profile.id);
        dataFile.append("username", user);
        dataFile.append("password", password);        

        //console.log(dataFile);
        fetch(process.env.REACT_APP_PUBLIC_URL + "profesional/create", {
          method: "POST",
          headers: {
            authorization: "Bearer " + sessionStorage.getItem("token"),
          },
          body: dataFile,
        })
          .then((response) => {
            if (response.status !== 500 && response.status !== 403) {
              setUseModal(true);
              history.push({
                pathname: process.env.PUBLIC_URL + "/config/manage-users",
              });
            }
          })
          .catch((error) => {
            alert("No se pudo crear el profesional");
            console.error("Error:", error);
          });
      }
    } else {
      validate("No");
    }
  };

  const updateUser = () => {
    if (!validate(professional)) {
      var data = {
        tipDoc: typeDocument,
        numDoc: documentNumber,
        ape1: lastName1,
        ape2: lastName2,
        nombres: name,
        sexo: gender.value,
        fec_nacimiento: moment(birthday).format("YYYY/MM/DD"),
        direccion: {
          id_pais: country.value,
          id_dpto: department.value,
          id_ciudad: city.value,
          direccion: address,
        },
        tel_fijo: telephone,
        celular: cellphone,
        correo: email,
        username: user,
        password: password,
        id_perfil: profile.id,
      };

      fetch(process.env.REACT_APP_PUBLIC_URL + "usuario/update", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify(data),
      })
        .then((response) => {
          return response.text();
        })
        .then((data) => {
          console.log(data);
          alert("usuario creado correctamente");
          history.push({
            pathname: process.env.PUBLIC_URL + "/config/manage-users",
          });
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    }
  };

  const specialtiesOptions = () => {
    var specialtiesOpt = specialties.map((specialty) => {
      return {
        value: specialty.id_especialidad,
        label: specialty.especialidad,
      };
    });
    return specialtiesOpt;
  };

  const { classes } = props;

  return (
    <Container className="dashboard">
      <Row>
        <Col md={12}>
          <h3 style={{ marginBottom: 30 }}>Crear Usuarioss</h3>
          <Button
            style={{ marginBottom: 20 }}
            color="primary"
            size="sm"
            onClick={() => {
              history.push({
                pathname: process.env.PUBLIC_URL + "/config/manage-users",
              });
            }}
          >
            <ArrowBackIcon />
          </Button>
        </Col>
      </Row>
      <Row>
        <Card>
          <CardBody>
            <div className="form" style={{ flexDirection: "column" }}>
              <div style={{ flex: 1, flexDirection: "row", display: "flex" }}>
                <div className="form__form-group" style={{ margin: 10 }}>
                  <span className="form__form-group-label">
                    Nombre de Usuario
                  </span>
                  <div className="form__form-group-field">
                    <Field
                      key={`user`}
                      name={`user`}
                      component={renderField}
                      type="text"
                      placeholder={""}
                      value={user}
                      onChange={(e) => {
                        setUser(e.target.value);
                      }}
                      //meta={errors.hasOwnProperty("typeDocument")? { touched: true, error: errors.hasOwnProperty("typeDocument")? errors.typeDocument: '' }: {}}
                      meta={
                        errors.hasOwnProperty("user")
                          ? {
                              touched: errors.user !== "",
                              error: errors.hasOwnProperty("user")
                                ? errors.user
                                : "",
                            }
                          : {}
                      }
                    />
                  </div>
                </div>
                <div className="form__form-group" style={{ margin: 10 }}>
                  <span className="form__form-group-label">Contraseña</span>
                  <div className="form__form-group-field">
                    <Field
                      key={`password`}
                      name={`password`}
                      component={renderField}
                      type={"password"}
                      placeholder=""
                      value={password}
                      onChange={(e) => {
                        setPassword(e.target.value);
                      }}
                      meta={
                        errors.hasOwnProperty("password")
                          ? {
                              touched: errors.password !== "",
                              error: errors.hasOwnProperty("password")
                                ? errors.password
                                : "",
                            }
                          : {}
                      }
                    />
                  </div>
                </div>
                <div className="form__form-group" style={{ margin: 10 }}>
                  <span className="form__form-group-label">
                    Confirmar Contraseña
                  </span>
                  <div className="form__form-group-field">
                    <Field
                      key={`passwordConfirm`}
                      name={`passwordConfirm`}
                      component={renderField}
                      type={"password"}
                      placeholder=""
                      value={passwordConfirm}
                      onChange={(e) => {
                        setPasswordConfirm(e.target.value);
                      }}
                      meta={
                        errors.hasOwnProperty("passwordConfirm")
                          ? {
                              touched: errors.passwordConfirm !== "",
                              error: errors.hasOwnProperty("passwordConfirm")
                                ? errors.passwordConfirm
                                : "",
                            }
                          : {}
                      }
                    />
                  </div>
                </div>
              </div>

              <div style={{ flex: 1, flexDirection: "row", display: "flex" }}>
                <div className="form__form-group" style={{ margin: 10 }}>
                  <span className="form__form-group-label">Nombres</span>
                  <div className="form__form-group-field">
                    <Field
                      key={`name`}
                      name={`name`}
                      component={renderField}
                      type="text"
                      placeholder={""}
                      value={name}
                      onChange={(e) => {
                        setName(e.target.value);
                      }}
                      meta={
                        errors.hasOwnProperty("name")
                          ? {
                              touched: errors.name !== "",
                              error: errors.hasOwnProperty("name")
                                ? errors.name
                                : "",
                            }
                          : {}
                      }
                    />
                  </div>
                </div>
                <div className="form__form-group" style={{ margin: 10 }}>
                  <span className="form__form-group-label">
                    Primer Apellido
                  </span>
                  <div className="form__form-group-field">
                    <Field
                      key={`last-name-1`}
                      name={`last-name-1`}
                      component={renderField}
                      type="text"
                      placeholder={""}
                      value={lastName1}
                      onChange={(e) => {
                        setLastName1(e.target.value);
                      }}
                      meta={
                        errors.hasOwnProperty("lastName1")
                          ? {
                              touched: errors.lastName1 !== "",
                              error: errors.hasOwnProperty("lastName1")
                                ? errors.lastName1
                                : "",
                            }
                          : {}
                      }
                    />
                  </div>
                </div>
                <div className="form__form-group" style={{ margin: 10 }}>
                  <span className="form__form-group-label">
                    Segundo Apellido
                  </span>
                  <div className="form__form-group-field">
                    <Field
                      key={`last-name-2`}
                      name={`last-name-2`}
                      component={renderField}
                      type="text"
                      placeholder={""}
                      value={lastName2}
                      onChange={(e) => {
                        setLastName2(e.target.value);
                      }}
                      meta={
                        errors.hasOwnProperty("lastName2")
                          ? {
                              touched: errors.lastName2 !== "",
                              error: errors.hasOwnProperty("lastName2")
                                ? errors.lastName2
                                : "",
                            }
                          : {}
                      }
                    />
                  </div>
                </div>
              </div>
              <div style={{ flex: 1, flexDirection: "row", display: "flex" }}>
                <div className="form__form-group" style={{ margin: 10 }}>
                  <span className="form__form-group-label">
                    Tipo de Documento
                  </span>
                  <div className="form__form-group-field">
                    <Field
                      name="select"
                      component={renderSelectField}
                      placeholder={"Tipo de documento"}
                      value={typeDocument}
                      onChange={(event) => {
                        console.log(event);
                        setTypeDocument(event);
                      }}
                      options={[
                        { value: "CC", label: "CEDULA DE CIUDADANIA" },
                        { value: "CE", label: "CEDULA DE EXTRANJERIA" },
                        { value: "PA", label: "PASAPORTE" },
                        { value: "CD", label: "CARNET DIPLOMATICO" },
                        { value: "SC", label: "SALVO CONDUCTO" },
                      ]}
                      disabled={false}
                      meta={
                        errors.hasOwnProperty("typeDocument")
                          ? {
                              touched: errors.typeDocument !== "",
                              error: errors.hasOwnProperty("typeDocument")
                                ? errors.typeDocument
                                : "",
                            }
                          : {}
                      }
                    />
                  </div>
                </div>
                <div className="form__form-group" style={{ margin: 10 }}>
                  <span className="form__form-group-label">
                    Número de Documento
                  </span>
                  <div className="form__form-group-field">
                    <Field
                      key={`document-number`}
                      name={`document-number`}
                      component={renderField}
                      type="text"
                      placeholder={""}
                      value={documentNumber}
                      onChange={(e) => {
                        setDocumentNumber(e.target.value);
                      }}
                      meta={
                        errors.hasOwnProperty("documentNumber")
                          ? {
                              touched: errors.documentNumber !== "",
                              error: errors.hasOwnProperty("documentNumber")
                                ? errors.documentNumber
                                : "",
                            }
                          : {}
                      }
                    />
                  </div>
                </div>
                <div className="form__form-group" style={{ margin: 10 }}>
                  <span className="form__form-group-label">Genero</span>
                  <div className="form__form-group-field">
                    <Field
                      name="select-gender"
                      component={renderSelectField}
                      placeholder={"genero"}
                      value={gender}
                      onChange={(event) => {
                        setGender(event);
                      }}
                      options={[
                        { value: "Masculino", label: "Masculino" },
                        { value: "Femenino", label: "Femenino" },
                      ]}
                      disabled={false}
                      meta={
                        errors.hasOwnProperty("gender")
                          ? {
                              touched: errors.gender !== "",
                              error: errors.hasOwnProperty("gender")
                                ? errors.gender
                                : "",
                            }
                          : {}
                      }
                    />
                  </div>
                </div>
              </div>

              <div style={{ flex: 1, flexDirection: "row", display: "flex" }}>
                <div className="form__form-group-field" style={{ margin: 10 }}>
                  <MuiPickersUtilsProvider utils={MomentUtils}>
                    <DatePicker
                      disableFuture
                      className={classes.date}
                      label="Fecha de Nacimiento"
                      views={["year", "month", "date"]}
                      value={birthday}
                      onChange={(date) => {
                        setBirthday(new Date(date));
                      }}
                      animateYearScrolling
                      format="yyyy/MM/D"
                      //error={this.state.errors.hasOwnProperty("birthday")? this.state.errors.birthday != "": false }
                      //helperText={this.state.errors.birthday}
                    />
                  </MuiPickersUtilsProvider>
                </div>
                <div className="form__form-group" style={{ margin: 10 }}>
                  <span className="form__form-group-label">Celular</span>
                  <div className="form__form-group-field">
                    <Field
                      key={`cellphone`}
                      name={`cellphone`}
                      component={renderField}
                      type="text"
                      placeholder={""}
                      value={cellphone}
                      onChange={(e) => {
                        setCellphone(e.target.value);
                      }}
                      meta={
                        errors.hasOwnProperty("cellphone")
                          ? {
                              touched: errors.cellphone !== "",
                              error: errors.hasOwnProperty("cellphone")
                                ? errors.cellphone
                                : "",
                            }
                          : {}
                      }
                    />
                  </div>
                </div>
                <div className="form__form-group" style={{ margin: 10 }}>
                  <span className="form__form-group-label">
                    Teléfono (Fijo)
                  </span>
                  <div className="form__form-group-field">
                    <Field
                      key={`telephone`}
                      name={`telephone`}
                      component={renderField}
                      type="text"
                      placeholder={""}
                      value={telephone}
                      onChange={(e) => {
                        setTelephone(e.target.value);
                      }}
                      meta={
                        errors.hasOwnProperty("telephone")
                          ? {
                              touched: errors.telephone !== "",
                              error: errors.hasOwnProperty("telephone")
                                ? errors.telephone
                                : "",
                            }
                          : {}
                      }
                    />
                  </div>
                </div>
              </div>

              <div style={{ flex: 1, flexDirection: "row", display: "flex" }}>
                <div className="form__form-group" style={{ margin: 10 }}>
                  <span className="form__form-group-label">País</span>
                  <div className="form__form-group-field">
                    <Field
                      name="select_country"
                      component={renderSelectField}
                      value={country}
                      meta={{
                        touched: errors.hasOwnProperty("country"),
                        error: errors.hasOwnProperty("country")
                          ? errors.country
                          : "",
                      }}
                      onChange={(e) => {
                        setCountry(e);
                        setDepartment({});
                        setCity({});
                        setCities([]);
                        const { dispatch } = props;
                        dispatch(
                          change("add_user_form", "select_department", "")
                        );
                        dispatch(change("add_user_form", "select_city", ""));
                        loadDepartment(e.value).then((departamentos) => {
                          setDepartments(departamentos);
                        });
                      }}
                      options={countriesOption()}
                    />
                  </div>
                </div>

                <div className="form__form-group" style={{ margin: 10 }}>
                  <span className="form__form-group-label">Departamento</span>
                  <div className="form__form-group-field">
                    <Field
                      name="select_department"
                      component={renderSelectField}
                      value={department}
                      meta={{
                        touched: errors.hasOwnProperty("department"),
                        error: errors.hasOwnProperty("department")
                          ? errors.department
                          : "",
                      }}
                      onChange={(e) => {
                        setDepartment(e);
                        setCity({});
                        const { dispatch } = props;
                        dispatch(change("add_user_form", "select_city", ""));
                        loadCities(e.value).then((cities) => {
                          setCities(cities);
                        });
                      }}
                      options={departmentsOption()}
                    />
                  </div>
                </div>
                <div className="form__form-group" style={{ margin: 10 }}>
                  <span className="form__form-group-label">Ciudad</span>
                  <div className="form__form-group-field">
                    <Field
                      name="select_city"
                      component={renderSelectField}
                      value={city}
                      meta={{
                        touched: errors.hasOwnProperty("city"),
                        error: errors.hasOwnProperty("city") ? errors.city : "",
                      }}
                      onChange={(e) => {
                        setCity(e);
                      }}
                      options={citiesOptions()}
                    />
                  </div>
                </div>
              </div>

              <div style={{ flex: 1, flexDirection: "row", display: "flex" }}>
                <div className="form__form-group" style={{ margin: 10 }}>
                  <span className="form__form-group-label">Dirección</span>
                  <div className="form__form-group-field">
                    <Field
                      key={`address`}
                      name={`address`}
                      component={renderField}
                      type="text"
                      placeholder={""}
                      value={address}
                      onChange={(e) => {
                        setAddress(e.target.value);
                      }}
                    />
                  </div>
                </div>

                <div className="form__form-group" style={{ margin: 10 }}>
                  <span className="form__form-group-label">
                    Correo electrónico
                  </span>
                  <div className="form__form-group-field">
                    <Field
                      key={`email`}
                      name={`email`}
                      component={renderField}
                      type="email"
                      placeholder="example@mail.com"
                      value={email}
                      onChange={(e) => {
                        setEmail(e.target.value);
                      }}
                      meta={
                        errors.hasOwnProperty("email")
                          ? {
                              touched: errors.email !== "",
                              error: errors.hasOwnProperty("email")
                                ? errors.email
                                : "",
                            }
                          : {}
                      }
                    />
                  </div>
                </div>

                <div className="form__form-group" style={{ margin: 10 }}>
                  <span className="form__form-group-label">Cargo</span>
                  <div className="form__form-group-field">
                    <Field
                      name="select_charge"
                      component={renderSelectField}
                      value={charge}
                      onChange={(e) => {
                        setCharge(e.value);
                      }}
                      options={cargosOptions()}
                      meta={{
                        touched: errors.hasOwnProperty("charge"),
                        error: errors.hasOwnProperty("charge")
                          ? errors.charge
                          : "",
                      }}
                    />
                  </div>
                </div>
              </div>

              <div
                style={{
                  flex: 1,
                  flexDirection: "row",
                  display: "flex",
                }}
              >
                <div className="form__form-group" style={{ margin: 10 }}>
                  <span className="form__form-group-label">Perfil</span>
                  <div className="form__form-group-field">
                    <Field
                      name="select_profile"
                      component={renderSelectField}
                      className="form__form-group-input-wrap--error-above"
                      value={profile}
                      meta={{
                        touched: errors.hasOwnProperty("profile"),
                        error: errors.hasOwnProperty("profile")
                          ? errors.profile
                          : "",
                      }}
                      onChange={(e) => {
                        setProfile(e);
                        console.log(e);
                        if (e.value === 10) {
                          setProfessional("Si");
                        } else {
                          setProfessional("No");
                        }
                        //const { dispatch } = props;
                        //dispatch(change('add_user_form', 'select_city', ''));
                      }}
                      options={profilesOptions()}
                    />
                  </div>
                </div>
                <div className="form__form-group" style={{ margin: 10 }}>
                  <span className="form__form-group-label">Rol</span>
                  <div className="form__form-group-field">
                    <Field
                      name="select_role"
                      component={renderSelectField}
                      value={rol}
                      onChange={(e) => {
                        setRol(e.value);
                      }}
                      options={roles}
                      meta={{
                        touched: errors.hasOwnProperty("rol"),
                        error: errors.hasOwnProperty("rol") ? errors.rol : "",
                      }}
                    />
                  </div>
                </div>
                <div className="form__form-group" style={{ margin: 10 }}>
                  <span className="form__form-group-label">Dependencia</span>
                  <div className="form__form-group-field">
                    <Field
                      name="select_dependencia"
                      component={renderSelectField}
                      value={dependencia}
                      onChange={(e) => {
                        setDependencia(e.value);
                      }}
                      options={dependencias}
                      meta={{
                        touched: errors.hasOwnProperty("dependencia"),
                        error: errors.hasOwnProperty("dependencia")
                          ? errors.dependencia
                          : "",
                      }}
                    />
                  </div>
                </div>
              </div>
              {professional === "Si" ? (
                <div className="form__form-group">
                  <div style={{ display: "flex" }}>
                    <div
                      className="form__form-group"
                      style={{ marginRight: "10px" }}
                    >
                      <span className="form__form-group-label">
                        Registro Medico
                      </span>
                      <div className="form__form-group-field">
                        <Field
                          key={`medical-record`}
                          name={`medical-record`}
                          component={renderField}
                          type="text"
                          placeholder={""}
                          value={medicalRecord}
                          onChange={(e) => {
                            setMedicalRecord(e.target.value);
                          }}
                          meta={{
                            touched: errors.hasOwnProperty("medicalRecord"),
                            error: errors.hasOwnProperty("medicalRecord")
                              ? errors.medicalRecord
                              : "",
                          }}
                        />
                      </div>
                    </div>
                    <div
                      className="form__form-group"
                      style={{ marginLeft: "10px" }}
                    >
                      <span className="form__form-group-label">Rethus</span>
                      <div className="form__form-group-field">
                        <Field
                          key={`rethus`}
                          name={`rethus`}
                          component={renderField}
                          type="text"
                          placeholder={""}
                          value={rethus}
                          onChange={(e) => {
                            setRethus(e.target.value);
                          }}
                          meta={{
                            touched: errors.hasOwnProperty("rethus"),
                            error: errors.hasOwnProperty("rethus")
                              ? errors.rethus
                              : "",
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div style={{ display: "flex" }}>
                    <div
                      className="form__form-group"
                      style={{ marginRight: "10px" }}
                    >
                      <span className="form__form-group-label">
                        Licencia de Salud Ocupacional
                      </span>
                      <div className="form__form-group-field">
                        <Field
                          key={`occupational-health-license`}
                          name={`occupational-health-license`}
                          component={renderField}
                          type="text"
                          placeholder={""}
                          value={healthLicense}
                          onChange={(e) => {
                            setHealthLicense(e.target.value);
                          }}
                          meta={{
                            touched: errors.hasOwnProperty("healthLicense"),
                            error: errors.hasOwnProperty("healthLicense")
                              ? errors.healthLicense
                              : "",
                          }}
                        />
                      </div>
                    </div>
                    <div
                      className="form__form-group"
                      style={{ marginLeft: "10px" }}
                    >
                      <span className="form__form-group-label">
                        Especialidades
                      </span>
                      <div className="form__form-group-field">
                        <Field
                          name="select_specialty"
                          component={renderMultiSelectField}
                          className="form__form-group-input-wrap--error-above"
                          //value={specialty}
                          value={specialtiesSpec}
                          meta={{
                            touched: errors.hasOwnProperty("specialty"),
                            error: errors.hasOwnProperty("specialty")
                              ? errors.specialty
                              : "",
                          }}
                          onChange={(e) => {
                            setSpecialtySpec(e);
                            //setSpecialty(e);
                          }}
                          options={specialtiesOptions()}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="form__form-group">
                    <span className="form__form-group-label">
                      Agregar archivo Imagen Firma
                    </span>
                    <div className="form__form-group-field">
                      <Field
                        name="file"
                        component={renderFileInputField}
                        onChange={(e) => {
                          console.log(e);
                          setFile(e);
                        }}
                        meta={{
                          touched: errors.hasOwnProperty("file"),
                          error: errors.hasOwnProperty("file")
                            ? errors.file
                            : "",
                        }}
                      />
                    </div>
                  </div>
                </div>
              ) : null}
              <div>
                {userId == null ? (
                  <Button
                    style={{
                      marginBottom: 10,
                      marginRight: 10,
                    }}
                    color="primary"
                    onClick={() => {
                      createUser();
                    }}
                  >
                    Crear Usuario
                  </Button>
                ) : (
                  <Button
                    style={{
                      marginBottom: 10,
                      marginRight: 10,
                    }}
                    color="primary"
                    onClick={() => {
                      updateUser();
                    }}
                  >
                    Actualizar
                  </Button>
                )}
              </div>
            </div>
            <Modal
              open={openMap}
              onClose={(e) => {
                setOpenMap(!openMap);
              }}
              aria-labelledby="simple-modal-title"
              aria-describedby="simple-modal-description"
              //style={{zIndex: 1000 }}
            >
              <div
                style={{
                  position: "absolute",
                  backgroundColor: "white",
                  width: "80%",
                  height: "80%",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  padding: 20,
                }}
              ></div>
            </Modal>
          </CardBody>
        </Card>
        {load ? (
          <Modal
            open={load}
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
            style={{ zIndex: 1000 }}
          >
            <div
              style={{
                position: "absolute",
                backgroundColor: "#ffffff",
                width: 200,
                height: 200,
                top: "50%",
                left: "50%",
                transform: "translate(-50%,-50%)",
                display: "flex",
              }}
            >
              <div className="load__icon-wrap">
                <svg className="load__icon">
                  <path
                    fill="#4ce1b6"
                    d="M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z"
                  />
                </svg>
              </div>
            </div>
          </Modal>
        ) : null}
        <ModalTheme
          color="success"
          title="Usuario Creado con exito"
          modal={useModal}
          onOk={() => setUseModal(!useModal)}
          toggle={() => setUseModal(!useModal)}
        />
      </Row>
    </Container>
  );
};

export default reduxForm({
  form: "add_user_form", // a unique identifier for this form
})(withStyles(styles, { withTheme: true })(withTranslation("common")(AddUser)));
